// extracted by mini-css-extract-plugin
export var notices = "notices-module--notices--58011";